module.exports = __webpack_public_path__ + "2cfbe3e206bd480f9cb9df8e1405ea6a.jpg";